import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { initGoogleAdsConsentMode } from '@afrilink/ui';
import { routes } from './routes';
import { installErrorReporter } from './lib/errorReporter';
import './globals.css';
import '@fontsource-variable/inter/wght.css';

// Production monitoring (M3.13) — wires window.onerror + onunhandledrejection
// to the marketing-error-log Edge Function. First-party, no consent banner
// needed (no PII, no tracking — just the error itself).
installErrorReporter();

// Google Ads Consent Mode v2 defaults (denied) + gtag.js when configured.
// Must run before render so the consent default is set before any tag fires.
// Inert until siteConfig.googleAds.conversionId is set. See CONVERSION_
// TRACKING_ARCHITECTURE_2026-07-08.md (AD-5).
initGoogleAdsConsentMode();

const router = createBrowserRouter(routes);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>
);
